import Vue from "vue";
import Vuex from "vuex";
import axios from 'axios';
// 该指令必须在 store 创建之前执行
Vue.use(Vuex);

// Actions(行动): 处理交互行为
const actions = {
    // context: 简化版的 store；    value: 发送过来的数据
    changeDispatch(context, value) {
        console.log("actions", context, value);
        // 将数据 commit 给 mutations
        // 设置 2 个实参: commit 中的方法名 & 发送的数据
        context.commit("changeCommit", value);
    },
	doChangeLoop(context, value) {
		if(value){
			localStorage.setItem('app-loop',1);
		}else{
			localStorage.removeItem('app-loop');
		}
	    context.commit("changeLoop", value);
	},
	doChangeUserInfo(context, value) {
	    context.commit("changeUserInfo", value);
	},
	doChangeFullScreen(context, value) {
	    context.commit("changeFullScreen", value);
	},
	doChangePageSize(context, value) {
	    context.commit("changePageSize", value);
	},
	doLoginOut(context,that) {
	    axios.post(context.state.base_url+'Monitor_Center/logout').then(function (response) {
	    	if(response.status === 200 && response.data.code==1 ){
	    		localStorage.removeItem('app-token');
	    		localStorage.removeItem('app-user-info');
	    		context.commit("changeCommit",'');
	    		context.commit("changeUserInfo",{});
				helps(that,'退出登录');
	    	}else{
	    		helps(that,response.data.info||'退出失败');
	    	}
	    }).catch(function (error) { 
	    	helps(that,error.toString());
	    }).finally(function () {});
	},
};
const helps = function(that,message,icon='warning'){
	that.$swal({
		position: 'center',
		icon:icon,
		title: message,
		showConfirmButton: false,
		timer: 1000,
		width:200
	});
};
// Mutations(变化): 修改 state 中的数据
const mutations = {
    changeCommit(state, value) {
        console.log("mutations", state, value);
        state.token = value;
    },
	changeLoop(state, value) {
	    state.isLoop = value;
	},
	changeUserInfo(state, value) {
		console.log(value);
	    state.user_info = value;
	},
	changeFullScreen(state, value) {
	    state.isFullScreen = value;
	},
	changePageSize(state, value) {
	    state.page_size = value;
	},
};

// State: 用于存储数据
const state = { 
	base_url:'https://www.jinchuangco.com/api/',
	token: "" ,
	user_info:{},
	isLoop:false,
	isFullScreen:false,
	page_size:'16'
};

// 创建并导出 store
export default new Vuex.Store({
    actions,
    mutations,
    state,
});
